import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DTypeForm, DTypeFormGroup } from '@grupo-constant/next-dtype/form';
import { DType } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { DialogsService } from '../dialogs.service';
import { NextTaskTypeGoal, NextTaskTypeGoalResume } from '../../core/task-type/task-type.types';
import { DTypeService } from '../../core/dtype/dtype.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { FuseConfirmationDialogComponent } from '../../../@fuse/services/confirmation/dialog/dialog.component';

@Component({
    selector: 'app-task-type-goal-dialog',
    templateUrl: './task-type-goal-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaskTypeGoalDialogComponent implements OnInit {

    dTypeForm: DTypeForm;
    item: NextTaskTypeGoal;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            item: NextTaskTypeGoal;
            dType: DType;
            update: boolean;
            existingGoals: NextTaskTypeGoalResume[];
        },
        public dialogRef: MatDialogRef<TaskTypeGoalDialogComponent>,
        private dialogsService: DialogsService,
        private dTypeService: DTypeService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService
    ) { }

    ngOnInit() {
        this.item = cloneDeep(this.data.item ?? { });
        this.dTypeForm = this.dTypeService.getDtypeFormFromDtype(
            this.data.dType,
            this.item,
            {
                readonly: false,
                isUpdate: this.data.update
            }
        );
    }

    save() {
        const goal = this.dTypeForm.control;
        goal.markAllAsTouched();
        if (goal.valid) {
            const goalName = goal.get('name').value;
            if (this.isValidGoalDefinition(goal)) {
                const confirmDialog = this.openConfirmDialog(this.transloco.translate('saveDataItemConfirm'));
                confirmDialog.afterClosed().subscribe((confirm) => {
                    if (confirm === 'confirmed') {
                        this.closeDialog(goal.value);
                    }
                });
            } else {
                this.dialogsService.openErrorDialog({
                    message: this.transloco.translate('goal.goalNameIsAlreadyOnUse', { name: goalName })
                });
            }
        } else {
            this.dialogsService.openErrorDialog({
                message: this.transloco.translate('errorsInForm')
            });
        }
    }

    closeDialog(result?: NextTaskTypeGoal): void {
        this.dialogRef.close(result);
    }

    private isValidGoalDefinition(goal: DTypeFormGroup): boolean {
        const name = goal.get('name').value;
        const from = goal.get('from').value;
        const to = goal.get('to').value;

        if (this.data.item && name === this.data.item.name && from === this.data.item.from) {
            return true;
        }

        for (const currentGoal of this.data.existingGoals) {
            if (name === currentGoal.name && from === currentGoal.from) {
                return false;
            }
        }
        return true;
    }

    private openConfirmDialog(message: string): MatDialogRef<FuseConfirmationDialogComponent, any> {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: message,
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
